// RiskRow.jsx 📄 Collapsible Risk Entry – Compatible with updated risk_main schema
import React from "react";
import RiskRowDetails from "./RiskRowDetails";

const RiskRow = ({
  risk,
  isExpanded,
  toggleCollapse,
  onEdit,
  onDelete,
  onRefresh,
  showToast,
  userCountry,
  onAddMesure,
  onAddTreatment,
  onEditTreatment, // ✅ required for editing treatment plans
}) => {
  const {
    id,
    name,
    criterion,
    responsible,
    business_unit,
    process,
    risk_level,
    country_code,
  } = risk;

  // 🎌 Convert country code to flag emoji
  const getFlagEmoji = (cc) =>
    cc?.toLowerCase() === "unknown"
      ? "🌐"
      : String.fromCodePoint(...[...cc?.toUpperCase()].map((c) => 127397 + c.charCodeAt(0)));

  // 🔥 Risk level badge style
  const getRiskBadgeClass = (level) => {
    const l = level?.toLowerCase();
    if (l === "critical") return "risk-level-critical";
    if (l === "high") return "risk-level-high";
    if (l === "medium") return "risk-level-medium";
    return "risk-level-low";
  };

  return (
    <>
      {/* 🔹 Collapsible Table Row */}
      <tr
        onClick={toggleCollapse}
        style={{ cursor: "pointer", backgroundColor: "#282727" }}
      >
        <td className="risk-title-cell" style={{ color: "#f8f9fa", backgroundColor: "#282727" }}>
          {name}
        </td>
        <td style={{ color: "#f8f9fa", backgroundColor: "#282727" }}>
          {getFlagEmoji(country_code)} <span className="text-uppercase">{country_code}</span>
        </td>
        <td style={{ color: "#f8f9fa", backgroundColor: "#282727" }}>
          {business_unit}
        </td>
        <td style={{ color: "#f8f9fa", backgroundColor: "#282727" }}>
          {responsible}
        </td>
        <td style={{ textAlign: "center", backgroundColor: "#282727" }}>
          <span className={`badge ${getRiskBadgeClass(risk_level)}`}>
            {risk_level || "N/A"}
          </span>
        </td>
      </tr>

      {/* 🔽 Expandable Detail Component */}
      <RiskRowDetails
        risk={risk}
        isExpanded={isExpanded}
        onEdit={onEdit}
        onDelete={onDelete}
        onRefresh={onRefresh}
        showToast={showToast}
        userCountry={userCountry}
        onAddMesure={onAddMesure}
        onAddTreatment={onAddTreatment}
        onEditTreatment={onEditTreatment} // ✅ passthrough to details
      />
    </>
  );
};

export default RiskRow;
